import { connect } from 'react-redux';
import { useCallback, useMemo } from 'react';

import { Row } from 'UIPackage/FormModule/components/Row';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { booleanSelectOptions } from 'KnmPackage/MainModule/constants/booleanSelectOptions';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  getDecisionEventHasUnplannedActivity,
  getDecisionFormRef,
  getKnmIsDecisionStatusFillInProcess,
} from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { IDecisionActForm } from 'DecisionPackage/MainModule/interfaces/IDecisionActForm';
import { IS_NEED_TO_ADD_ACT_ID } from 'CorePackage/MainModule/routes/routes';
import { getUserRoleIsSupervisor } from 'AuthPackage/MainModule/selectors/authSelectors';

import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { getTitleFieldWithRedStar } from '../../../functions/getTitleFieldWithRedStar';

interface IDecisionWillBeActProps {
  watchOnly: boolean;
  act?: IDecisionActForm;
}

interface IDecisionWillBeActStoreProps {
  formRef: IDecisionFormRef | undefined;
  isSupervisor: boolean;
  isDecisionStatusFillInProcess: boolean;
  availableUnplannedActivities: boolean | undefined;
}

const DecisionWillBeActWithoutStore = ({
  watchOnly,
  act,
  formRef,
  isSupervisor,
  isDecisionStatusFillInProcess,
  availableUnplannedActivities,
}: IDecisionWillBeActProps & IDecisionWillBeActStoreProps) => {
  const onChange = useCallback(() => {
    // @ts-ignore
    formRef?.current.change('organization.act');
  }, [formRef]);

  const isDisabled = useMemo(() => {
    return watchOnly || (act ? !act?.isNew : false) || !isSupervisor || !isDecisionStatusFillInProcess;
  }, [watchOnly, act, isSupervisor, isDecisionStatusFillInProcess]);

  const options = useMemo(
    () => (!availableUnplannedActivities ? booleanSelectOptions.filter(opt => opt.value) : booleanSelectOptions),
    [availableUnplannedActivities],
  );

  return (
    <FieldBlock
      label={getTitleFieldWithRedStar({
        label: `Будет ли добавлен акт`,
        field: `isNeedToAddAct`,
        isDecision: true,
      })}
      size="half"
    >
      <Row>
        <SelectInputField
          id={IS_NEED_TO_ADD_ACT_ID}
          className="shared-row-flex"
          name={'isNeedToAddAct'}
          options={options}
          isClearable={false}
          disabled={isDisabled}
          onChange={onChange}
          size="medium"
        />
      </Row>
    </FieldBlock>
  );
};

const mapStateToProps = (state: IRootState): IDecisionWillBeActStoreProps => ({
  formRef: getDecisionFormRef(state),
  isSupervisor: getUserRoleIsSupervisor(state),
  isDecisionStatusFillInProcess: getKnmIsDecisionStatusFillInProcess(state),
  availableUnplannedActivities: getDecisionEventHasUnplannedActivity(state),
});

export const DecisionWillBeAct = connect(mapStateToProps)(DecisionWillBeActWithoutStore);
